import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAvatar,{class:{ 'avatar-left': _vm.left },attrs:{"size":_vm.size,"color":"grey"}},[(_vm.imgSrc)?_c('img',{staticClass:"avatar-img",attrs:{"src":_vm.imgSrc,"alt":"avatar"}}):_c(VIcon,{attrs:{"color":"white","size":"24"}},[_vm._v("$account")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }